import React from 'react';
import './Tutorial.css';

const Tutorial = ({ onClose }) => {
  return (
    <div className="tutorial-overlay">
      <div className="tutorial-content">
        <div className="tutorial-header">
          <h2>数独マスターの遊び方</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="tutorial-body">
          <section className="tutorial-section">
            <h3>ゲームの目的</h3>
            <p>
              数独マスターの通常モードは、完成した数独から交互に数字を消していき、
              解の一意性（答えが1つだけであること）を保てなくなった人が負けとなるゲームです。
            </p>
          </section>
          
          <section className="tutorial-section">
            <h3>基本ルール</h3>
            <ol>
              <li>プレイヤーは交互に任意の数字を1つ消します。</li>
              <li>数字を消した後も、数独の解が唯一でなければなりません。</li>
              <li>複数の解が存在するようになった場合、その手を指したプレイヤーの負けです。</li>
            </ol>
          </section>
          
          <section className="tutorial-section">
            <h3>ゲームの流れ</h3>
            <ol>
              <li>完成した数独盤面からスタートします。</li>
              <li>プレイヤー1から始めて、交互に数字を消していきます。</li>
              <li>各ターンで消す数字は1つだけです。</li>
              <li>すでに消された数字は選べません。</li>
              <li>ゲームは、どちらかのプレイヤーが解の一意性を壊すまで続きます。</li>
            </ol>
          </section>
          
          <section className="tutorial-section">
            <h3>勝利条件</h3>
            <p>
              相手プレイヤーが一意解を保てない数字を消してしまった場合に勝利します。
              つまり、相手の消した数字によって、複数の解が存在するようになった場合に勝ちとなります。
            </p>
          </section>
          
          <section className="tutorial-section">
            <h3>ヒントとコツ</h3>
            <ul>
              <li>
                <strong>対称性のある数字から消す：</strong>
                盤面の対称的な位置にある数字は、比較的安全に消せることが多いです。
              </li>
              <li>
                <strong>制約の多い数字を残す：</strong>
                同じ行、列、3×3ブロック内で多くの制約を受ける数字は
                一意性の維持に重要な場合が多いため、消さないようにしましょう。
              </li>
              <li>
                <strong>相手の選択肢を制限する：</strong>
                最終盤では、相手に危険な選択肢しか残さないような戦略が有効です。
              </li>
            </ul>
          </section>
          
          <section className="tutorial-section">
            <h3>ゲームオーバー後</h3>
            <p>
              ゲーム終了時には詳細な解説が表示されます。失敗したマスがなぜ
              一意性を壊したのか、また最適解の表示機能で、あと何マス消せるかを
              確認することができます。これを参考に次のゲームでの戦略を練りましょう。
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Tutorial;
